import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ChartComponent,
  ApexPlotOptions,
  ApexLegend,
  ApexStroke,
  ApexDataLabels,
  ApexStates,
  ApexTooltip
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  colors: any;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  stroke: ApexStroke,
  dataLabels: ApexDataLabels,
  states: ApexStates
  tooltip: ApexTooltip
};

@Component({
  selector: 'app-advanced-pie-chart',
  templateUrl: './advanced-pie-chart.component.html',
  styleUrls: ['./advanced-pie-chart.component.scss']
})

export class AdvancedPieChartDialogComponent implements OnInit {
  // @Input() data: any[];
  // view: any[] = [700, 400];

  selectedOption: string = '1';
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AdvancedPieChartDialogComponent>,
    ) {
    // console.log(data, 'data new here')

    this.donutChart();
   }

  ngOnInit(): void {
  }

  closeDilog(){
    this.dialogRef.close();
  }

  donutChart() {
    const totalChartValue = this.data.totalValue;
    const labels = this.data.elements.map(item => item.name);
    const series = this.data.elements.map(item => item.value);
    const colors = this.data.elements.map(item => item.color);
    const clickedData = this.data.clickedItem;
    // console.log(clickedData, 'clickedData')
    const selectedValue = this.selectedOption;
    this.chartOptions = {
      series: series,
      labels: clickedData === 'title' ? ['0', '0-3.9', '4.0-4.4', '4.5-6' ] : ['0', '0-3', '4', '5-6' ],
      tooltip: {
        enabled: false
      },
      dataLabels: {
        enabled: true,
        // textAnchor: 'middle',
        formatter: function (val: any, opts) {
          const series = opts.w.config.series[opts.seriesIndex];
          let formattedValue = '';
          switch (selectedValue) {
            case '1':
              // let pieValue = `(${((Math.floor(100 * val) / 100).toFixed(1) as any) % 1 === 0 ? (Math.floor(100 * val) / 100).toFixed(0) : (Math.floor(100 * val) / 100).toFixed(1)}%)`;
              let pieValue = `(${(Math.floor(100 * val) / 100).toFixed()}%)`;
              formattedValue = [series, pieValue] as any;
              // formattedValue = `${series} (${val % 1 === 0 ? val.toFixed(0) : val.toFixed(1)}%)`; 
                break;
            case '2':
                formattedValue = `${series}`;
                break;
            case '3':
                formattedValue = `(${(Math.floor(100 * val) / 100).toFixed()}%)`;
                break;
            default:
                // formattedValue = `${series} (${val % 1 === 0 ? val.toFixed(0) : val.toFixed(1)}%)`; 
                formattedValue = [series, pieValue] as any;
                break;
          }
          return formattedValue;
        },
      
        style: {
          fontSize: '18px',
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 500,
          // colors: ['#a8aab7', '#FD6845', '#FD9326', '#81C600']
          colors: ['#313640', '#FFFFFF', '#FFFFFF', '#FFFFFF']
        },
        background: {
          enabled: false
        },
        dropShadow: {
          enabled: true,
          top: 2,
          left: 0,
          blur: 1,
          opacity: 0.2,
          color: '#000000'
        },
        offsetY: -30
      },
      chart: {
        type: "donut",
        width: '100%',
        // height: '500px',
        animations: {
          enabled: false
        }
      },
      legend: {
        show: true,
        position:'bottom',
        offsetY: 7,
        fontFamily: 'Montserrat, sans-serif',
        fontSize:'14px',
        fontWeight: 400,
        labels: {
          colors: '#848A9C'
        },
        onItemClick: {
          toggleDataSeries: false
        },
        onItemHover: {
          highlightDataSeries: false
        }
      },
      colors: colors,
      plotOptions : {
        pie: {
          startAngle: 0,
          endAngle: 360,
          expandOnClick: false,
          offsetX: 0,
          offsetY: 0,
          // customScale: 0.8,
          customScale: 1,
          dataLabels: {
            // offset: selectedValue === '2' ? 82 : selectedValue === '3' ? 86 : 98,
            offset:0,
            minAngleToShowLabel: 1
          }, 
          donut: {
            // size: '60%',
            size: '48%',
            background: 'transparent',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '18px',
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 800,
                color: '#FFFFFF',
                offsetY: -5
              },
              value: {
                show: true,
                fontSize: '18px',
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 700,
                color: '#243465',
                offsetY: 1
              },
              total: {
                show: true,
                showAlways: true,
                label: 'Total',
                fontSize: '14px',
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 400,
                color: '#848A9C',
                formatter: function (w) {
                  return totalChartValue.toString();
                }
              }
            }
          },      
        }
      },
      states: {
        normal: {
          filter: {
            type: 'none'
          }
        },
        hover: {
          filter: {
            type: 'none'
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none'
          }
        }
      },
      stroke: {
        width: 0
      }
      // responsive: [
  
      //   {
      //     breakpoint: 480,
      //     options: {
      //       chart: {
      //         width: 200
      //       },
      //     }
      //   }
      // ]
    };
  }

  onAnalyseChange(event) {
    this.selectedOption = event.value;
    this.donutChart();
  }
}
